import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert, FormCheck } from 'react-bootstrap';
import AreaN1DataService from "./services/arean1.service";
import { Navigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useEffect } from 'react';
import { IoIosArrowBack } from "react-icons/io";
//import SublocationsList from './AreaN2List';
//import NewSublocation from './NewSublocation';
import { PageHeader } from './AuxiliaryFunctions';
import NewAreaN2 from './NewAreaN2';
import AreasN2List from './AreasN2List';
import ExportSidebar from './ProSideBar';
import Sidebar from './Sidebar';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const EditAreaN1Page = (props) => {    
  let params = useParams();
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [arean1id, setarean1id] = useState(params.id);
  const [nombrearea, setnombrearea] = useState('');
  const [descripcionarea, setdescripcionarea] = useState('');
  const [arean1active, setarean1active] = useState('');
  const [listOfAreasN2, setlistOfAreasN2] = useState([]);

  const onChangenombrearea = (e) => {
    setnombrearea(e.target.value);
  } 

  const onChangedescripcionarea = (e) => {
    setdescripcionarea(e.target.value);
  } 

  const handleValidations = (e) => {
    if (nombrearea.length == 0) {
      setErrmessage('There are empty required fields.');
      setShowerror(true);
      return;
    }
    saveAreaN1();
  }

  useEffect(() => {
    retrieveAreaN1(arean1id);  
  }, [])

  const retrieveAreaN1 = (arean1id) => {
    AreaN1DataService.get(arean1id)
      .then(response => {
        setnombrearea(response.data.nombrearea);
        setdescripcionarea(response.data.descripcionarea);
        setarean1active(response.data.arean1active);
        setlistOfAreasN2(response.data.arean2);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message);
      });
  }


  let saveAreaN1 = ()  =>{   
    var data = {
        nombrearea: nombrearea,
        descripcionarea: descripcionarea,
        arean1active: arean1active,
    }    
    
    AreaN1DataService.update(params.id, data)
    .then(response => {
      setSubmitted(true);
      setSuccmessage('El área N1 ha sido actualizada. Redirigiendo a la lista de áreas...');
      setShowsuccess(true);
    })
    .catch(e => {
      console.log(e);
      setShowsuccess(false);
      setSuccmessage('');
      setShowerror(true);
      setErrmessage(e.response?e.response.data.message:e.message);      
    })        
  }  

  const goToAreasList = (e) => {
    window.location.assign('/areas')
  }
  
  return (
    <>
      <Sidebar />
      <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>
        <ExportSidebar />            
        <Container>
          <Row className='mb-4'>
            <PageHeader />
            <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Editar área N1</h5>
            <Col className='col-md-3' md={4}>
              <FormLabel className='mb-2'>Nombre área:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="internalidentifier" id="internalidentifier" onChange={onChangenombrearea} defaultValue={nombrearea}></FormControl>
            </Col>

            <Col md={8}>
              <FormLabel className='mb-2'>Descripción área:</FormLabel>       
              <FormControl type="text" name="descripcionarea" id="descripcionarea" onChange={onChangedescripcionarea} defaultValue={descripcionarea}></FormControl>
            </Col>          
          
            {showerror && (
              <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                <Alert.Heading>Error</Alert.Heading>
                <p>{errmessage}</p>
              </Alert>      
            )}
            {showsuccess && (
              <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                <Alert.Heading>Done</Alert.Heading>
                <p>{succmessage}</p>
            </Alert>      
            )}     
          {submitted ? (<Navigate push to="/areas"/>) : null }

          </Row>
          <Row className='mb-2'>
            <Col className='col-md-4'>
              <Button className='btn-secondary' id='saveItem' onClick={handleValidations}>Guardar área N1</Button>            
              <Button className='m-2 btn-secondary' id='goToAreasList' onClick={goToAreasList}><IoIosArrowBack/></Button>            
            </Col>
          </Row>          
          <Row className='mb-4'>
              <FormLabel>Areas N2</FormLabel>
              <Col className='mb-4 col-md-4'>
                  <NewAreaN2 retrieveAreaN1={retrieveAreaN1} arean1id={arean1id}></NewAreaN2>
              </Col>
              <AreasN2List mode={0} arean1id={arean1id} listOfAreasN2={listOfAreasN2}></AreasN2List>            
          </Row>                                     
        </Container>    
      </div>
    </>
  )

}

export default EditAreaN1Page;

